// Buffer circular em memória com as últimas ~20 ações do usuário (navegação
// de tela + chamada HTTP), anexado ao payload do relatório de erro no
// momento da captura (ticket #144). Sem tabela própria -- só um campo JSON
// no evento (ver spec #139).
const MAX_BREADCRUMBS = 20

let buffer = []

function push(crumb) {
  buffer.push({ ...crumb, at: new Date().toISOString() })
  if (buffer.length > MAX_BREADCRUMBS) buffer.shift()
}

export function addNavigationBreadcrumb(screen) {
  push({ type: 'navigation', screen })
}

export function addHttpBreadcrumb(endpoint, method, status) {
  push({ type: 'http', endpoint, method, status })
}

export function getBreadcrumbs() {
  return [...buffer]
}

export function clearBreadcrumbs() {
  buffer = []
}
